import { ReactComponent as InfoIcon } from 'resources/images/info.svg';
import { Icon, IconProps, forwardRef } from '@chakra-ui/react';
import React from 'react';

export const TooltipIcon = forwardRef((props: IconProps, ref) => (
  <Icon
    ref={ref}
    as={InfoIcon}
    cursor="pointer"
    color="M.60"
    width="initial"
    height="initial"
    data-testid="tooltip-icon"
    tabIndex={0}
    _focus={{
      outline: 'none',
    }}
    {...props}
  />
));
